import { React, useState, useRef, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import { useLanguage } from '../../Context/LanguageContext';
import { useTheme } from '../../Context/ThemeContext';
import { lightTheme, darkTheme } from '../../Styles/theme';

import FetchModule from '../../Model/Share/Network/FetchModule';

import SelectOffPath from '../../image/SelectOff.png';
import BlackPlusIcon from '../../image/BlackPlus.svg';
import CheckImage from '../../image/CheckImage.png';
import { ReactComponent as SearchingIcon } from '../../image/Searching.svg';

export default function MembershipSortingSelectBox(props) {
  const { value, setValue } = props;
  const { t } = useLanguage();
  const { isDark } = useTheme();
  const theme = isDark ? darkTheme : lightTheme;

  const [isClicked, setIsClicked] = useState(false);
  const [options, setOptions] = useState([]);
  const [tmpValue, setTmpValue] = useState([]);

  const TopLevelRef = useRef();
  const TotalSelectRef = useRef();
	const SelectRef = useRef();

  useEffect(() => {
    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.getDataVersion2('membership/', 'GET');
        
        if (responseData.status === 200) {
          setOptions(responseData.data.memberShips);
        }
      }
    )();
  }, [])

  useEffect(() => {
    let newTempValue = [];

    for (let i = 0; i < options.length; i++) {
      for (let j = 0; j < value.length; j++) {
        if (options[i].name === value[j].name) {
          newTempValue.push(options[i]);
        }
      }
    }

    setTmpValue(newTempValue);
  }, [value, options])

  // 컴포넌트 밖을 클릭하면 셀렉트 창 닫기
  useEffect(() => {
    document.addEventListener("mousedown", onClickOutSide);

    return () => {
      document.removeEventListener("mousedown", onClickOutSide);
    }
  }, [])

  // 컴포넌트 밖을 클릭하면 셀렉트 창 닫기
  function onClickOutSide(e) {
    if (TopLevelRef.current !== e.target && !TopLevelRef.current.contains(e.target)) {
      TotalSelectRef.current.style.height = '0px';
      TotalSelectRef.current.style.border = '0px';
      SelectRef.current.style.height = `0px`;
      SelectRef.current.style.overflow = 'hidden';
      setIsClicked(false);
    }
  }

  function onClick() {
    if (isClicked) {
      TotalSelectRef.current.style.height = '0px';
      TotalSelectRef.current.style.border = '0px';
      SelectRef.current.style.height = `0px`;
      SelectRef.current.style.overflow = 'hidden';
      setIsClicked(false);
    }
    else {
      TotalSelectRef.current.style.height = (32 * (options.length + 1 )) > 230 ? `264px` : (((32 * (options.length + 1)) + 36) + 'px');
      TotalSelectRef.current.style.border = `1px solid ${theme.primary}`;
      SelectRef.current.style.height = (32 * (options.length + 1 )) > 230 ? `230px` : ((32 * (options.length + 1)) + 'px');
      SelectRef.current.style.overflowY = 'scroll';
      SelectRef.current.style.overflowX = 'none';
      setIsClicked(true);
    }
  }

  // 회원권 클릭시 //
  function optionalClick(index) {
    // 입력시 중복확인 => 존재하면 삭제, 존재하지 않으면 추가
    let newDefaultVal = tmpValue.slice();

    if (newDefaultVal.includes(options[index])) {
      let deletedIndex = 0;

      newDefaultVal.filter(function(item, idx) {
        // 두개가 같으면
        if (options[index] === item) {
          deletedIndex = idx;
          return;
        }
      })

      newDefaultVal.splice(deletedIndex, 1);
      setTmpValue(newDefaultVal);
    }
    else {
      newDefaultVal.push(options[index]);
      setTmpValue(newDefaultVal);
    }
  }

  // 확인 버튼 클릭시 //
  function onClickComplete() {
    setValue(tmpValue);
    onClick();
  }
  
  // 초기화 버튼 클릭시 //
  function onClickReset() {
    setValue([]);
    setTmpValue([]);
    onClick();
  }

	return (
    <TopLevelWrapper ref={TopLevelRef}>
      <SearchButtonWrapper>
        <SearchButton $isClicked={isClicked} onClick={onClick}/>
      </SearchButtonWrapper>
      <TotalSelectBox ref={TotalSelectRef}>
      <SelectBox
        ref={SelectRef}
        isClicked={isClicked}>
        {
          options.map((data, index) =>
            <OptionWrapper key={index} onClick={() => optionalClick(index)}>
              <TextWrapper>
                <Option isClicked={tmpValue.includes(data)}>{data.name}</Option>
              </TextWrapper>
              { tmpValue.includes(data) && <Check src={CheckImage}/> }
            </OptionWrapper>
          )
        }
      </SelectBox>
      <CompleteButtonWrapper>
        <TextButton onClick={onClickComplete}>{t('validMember.confirm')}</TextButton>
        <TextButton onClick={onClickReset}>{t('validMember.reset')}</TextButton>
      </CompleteButtonWrapper>
      </TotalSelectBox>
    </TopLevelWrapper>
  )
}

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: column;

  width: 20px;
  height: 20px;
`;

const SearchButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  width: 20px;
  height: 20px;

  border-radius: 4px;

  background-color: ${props => props.theme.buttonFill};
`;

const SearchButton = styled(SearchingIcon)`
  width: 18px;
  height: 18px;

  border-radius: 4px;

  & path {
    fill: ${props => props.$isClicked ? props.theme.white : props.theme.line};
  }

  transition: all 0.3s ease-in-out;

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
    }
  }
`;

const Check = styled.img`
  width: 12px;
  height: 9px;
`;

const TotalSelectBox = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: 160px;
  height: 0px;

  margin-top: 25px;
  margin-left: -72px;

  border: 0px;
  border-radius: 8px;
  background-color: ${props => props.theme.subBackground};

  overflow: hidden;

  z-index: 2;

  transition: all 0.3s ease-in-out;
`;

const SelectBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: 144px;
  height: 0px;

  padding: 0 8px 0 8px;

  border: 0px;
  border-radius: 8px;
  background-color: ${props => props.theme.subBackground};

  overflow: hidden;

  z-index: 2;

  transition: all 0.3s ease-in-out;

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
    }
  }

  &::-webkit-scrollbar {
    width: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: ${props => props.theme.scrollBar};
    border-radius: 4px;
  }

  &::-webkit-scrollbar-track {
    background-color: ${props => props.theme.subBackground};
  }
`;

const OptionWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  width: 100%;

  margin: 6px 0px 6px 0px;

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
    }
  }
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  width: calc(100% - 16px);
  height: 19px;

  overflow: hidden;
`;

const Option = styled.p`
  font-family: NotoSansKR-Regular;
  font-size: 13px;

  color: ${props => props.isClicked ? props.theme.primary : props.theme.subText};

  margin: 0 0 0 0;
  padding: 0 0 0 0;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const CompleteButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  padding: 0px 8px 0px 8px;

  gap: 8px;

  width: calc(100% - 16px);
  height: 36px;

  border-top: 1px solid ${props => props.theme.line};
`;

const TextButton = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  font-family: NotoSansKR-Medium;
  font-size: 14px;

  color: ${props => props.theme.line};

  transition: all 0.3s ease-in-out;

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
      color: ${props => props.theme.primary};
    }
  }
`;